import { render } from "./RuleList.vue?vue&type=template&id=2d83347e"
import script from "./RuleList.vue?vue&type=script&lang=js"
export * from "./RuleList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__